import { Box } from "@chakra-ui/react";
import { matchHeadFontCss } from "containers/MatchContainer/MatchContainer";
import { getCdnImageSrc, Image, useResponsive, VStack } from "goi_common";
import React, { ReactNode } from "react";

export default function TrustSection() {
  const { setResponsive, isBiggerThanLg, isBiggerThanMd } = useResponsive();
  return (
    <VStack
      background="linear-gradient(180deg, #252525 58.33%, #000000 100%)"
      padding={isBiggerThanLg ? "100px 0px" : "60px 0px"}
      gap={isBiggerThanLg ? 16 : 12}
      alignItems="center"
    >
      <VStack alignItems="center" className="white" width="100%" css={matchHeadFontCss}>
        <div css={{ textAlign: "center" }}>
          한 번 뿐인 장례,
          <br />
          믿고 맡길 수 있어야 합니다
        </div>
      </VStack>

      <div
        css={{ textAlign: "center", lineHeight: isBiggerThanLg ? "36px" : "24px" }}
        className={isBiggerThanLg ? "head2_m gray50" : "body3_m gray50"}
      >
        20,000건 이상의 맞춤형 장례 견적 분석과
        <br />
        인터뷰, 레퍼런스 체크, 서비스 검증을 통해 {isBiggerThanLg || <br />}선별한 전문가
      </div>
      <Box
        display="flex"
        flexDirection={isBiggerThanMd ? "row" : "column"}
        gap="16px"
        paddingTop={setResponsive("24px", "40px")}
      >
        <MatchSangjoCard
          id=""
          title="제 부모님처럼 모시겠습니다"
          text="안녕하세요 장례지도사 최서규입니다. 아버지께 못다한 마음을 다른 가족분들께 전해드려야겠다고 생각하고 상조 회사를 설립하게 되었습니다. 초심을 잃지 않고 정말 제 부모님처럼 다른 부모님의 장례를 돕기 위해 노력하고 있습니다."
        />
        <MatchSangjoCard
          id="5"
          title={
            <>
              마음과 마음은
              <br />
              서로 통한다고 생각해요.
            </>
          }
          text="조용하지만 완벽하게 서포트하자. 이것이 제 철학입니다. 유가족분들께서 고인의 마지막 길을 후회 없이 배웅하실 수 있도록 최선을 다해 모시고 싶습니다. 이 따뜻한 손으로 고인의 마지막 길을 정성껏 모셔드려야겠다는 마음으로 임하고 있습니다."
        />
        <MatchSangjoCard
          id="3"
          title="장례다운 장례를 약속드립니다"
          text="장례는 치르는 것이 아니라 모시는 것이라 생각합니다. 저희 나눔라이프는 이러한 철학으로 나눔과 섬김, 그리고 감동을 실천하는 고품격 장례 토탈 전문 서비스 기업입니다. 전국 직영팀을 운영하고 있고, 차별화된 입관 서비스를 교육하는 등 고객 감동을 위해 노력하고 있습니다."
        />
      </Box>
    </VStack>
  );
}

function MatchSangjoCard({ id, title, text }: { id: string; text: string; title: ReactNode }) {
  const { setResponsive, isBiggerThanLg } = useResponsive();
  return (
    <VStack
      className="white"
      alignItems="center"
      background="black"
      borderRadius="16px"
      padding={setResponsive("16px", "16px")}
      width={setResponsive("278px", "225px", "320px", "340px")}
      height={setResponsive("400px", "400px", "400px", "506px")}
    >
      <VStack position="relative">
        <Image src={getCdnImageSrc(`platform/match/thumbnail${id}.png`)} alt="" />

        <VStack
          className="subtitle2_b"
          position="absolute"
          css={{ bottom: 20, textAlign: "center" }}
          alignItems="center"
          width="100%"
          gap={6}
        >
          {title}
          <Image
            width={id === "" ? "80px" : "100px"}
            src={getCdnImageSrc(`platform/match/logo${id}.png`)}
            alt=""
          />
        </VStack>
      </VStack>

      <div css={{ padding: "0px 10px" }} className={isBiggerThanLg ? "body2" : "body3_r"}>
        {text}
      </div>
    </VStack>
  );
}
